import styled from 'styled-components';
import { Retry } from '@components/common';
import breakpoint from 'styled-components-breakpoint';

export const LoadingWrapper = styled(Retry)`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const SPIMetricsDropDown = styled.div`
    width: 100%;
`;

export const HeaderContainer = styled.div`
    padding-bottom: 15px;
`;

export const SPIHeaderTitle = styled.div`
    font-size: 1rem;
    padding-bottom: 10px;
    display: flex;
    justify-content: space-between;
`;

export const KPIMetricText = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const AdminHeaderContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
`;

export const AdminIcon = styled.div`
  padding: 0px 10px;
  cursor: pointer;
  color: #8cc8ff;
  min-width: 20px;
`;

export const AdminCreateIcon = styled.div`
  cursor: pointer;
  color: #8cc8ff;
  min-width: 20px;
  display: flex;
`;

export const AdminKPIDropdown = styled.div`
  width: 50%;
`;

export const ErrorMessage = styled.div`
  color: red;
  font-weight: 300;
`;

export const SpiWidgetWrapper = styled.div`
  width:49%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  min-width: 300px;
  margin-right: 5px;
  margin-bottom: 5px;
  padding: 10px;
  box-sizing: border-box;
  flex-wrap: wrap;
`;

export const MetricNumbersTextWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
  justify-content: space-between;
`;

export const TextDivider = styled.div`
  background: #979797;
  opacity: 0.5;
  margin: 5px 0px;
  height: 1px;
`;

export const TextContainer = styled.div`
  display: flex;
  padding: 15px 10px 10px 0px;
  box-sizing: border-box;
`;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

export const IconHolder = styled.div`
  font-size: 1.5rem;
  box-sizing: border-box;
  cursor: pointer;
  width: 25px;
`;

export const PopUpMetric = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  box-sizing: border-box;
  justify-content: space-between;
  font-size: 16px;
  width: 100%;

  .ant-input-disabled {
    background-color: #EFEFEF !important;
    border: 1px solid #9B9B9B;
    color: #9B9B9B !important;
    width: 80px !important;
  }
  .ant-modal-header{
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
  }
`;

export const MetricUnit = styled.div`
  ${breakpoint('desktop')`
    width: 40%;
  `};

  ${breakpoint('tablet')`
      width: 40%;
  `};

  ${breakpoint('mobile')`
      width: 60%;
  `};
  display: flex;
  color: #9B9B9B;
  .ant-dropdown-trigger{
    width: 350px;
  }
  .ant-select-selection{
    width: 100px;
  }
`;

export const SPIStyle = styled.div`
  font-weight: 300;
  line-height: 22px;
`;

export const SPIThresholdsContainer = styled.div`{
  margin-top: 20px;
  border: 1px solid #9B9B9B;
  box-sizing: border-box;
  border-radius: 6px;
  padding: 15px 15px 0px 15px;
}`;
export const MetricName = styled.div`
  width: 50%;
  ${breakpoint('mobile')`
      width: 40%;
  `};
  font-weight: 300;
  line-height: 22px;
`;

export const MetricSign = styled.div`{
  padding: 0px 10px;
  Font-weight: 300;
  font-size: 16px;
  color: black;
  line-height: 2;
}`

export const SPIColors = {
  low: '#D0021B',
  medium: '#FABD43',
  high: '#00A150'
};

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const AverageContainer =  styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
`;

export const StreamsContainer =  styled.div`
  display: flex;
  align-items: flex-end;
`;

export const StreamsText = styled.div`
  font-size: 15px;
  font-weight: 600;
  padding-left: 15px;
`;
export const Numbers = styled.div`
  font-size: 16px;
  min-width: 50px;
`;

export const AverageText = styled.div`
  font-size: 14px;
  padding-left: 15px;
  font-weight: 300;
`;

export const StreamsWrapper = styled.div`
  height: 100px;
  margin-left: 15px;
`;

export const SPIChartScore = styled.div`
  display: flex;
  height: 120px;
  max-width: 60%;
  cursor: pointer;
`;

export const GaugeChart = styled.div`
  padding-top: 12px;
`;

export const CreateNewError = styled.div`
  font-size: 10px;
  color: red;
  padding: 10px 0px;
  width: 50%;
  cursor: pointer;
`;

export const OrDiv = styled.div`
  display: flex;
  align-items: center;
  color: #4A4A4A;
  padding: 5px 0px;
  padding-bottom: 10px;
`;

export const OrBorder = styled.div`
  width: 45%;
  border: 1px #4A4A4A;
  margin: 10px 0px;
  opacity: 0.5;
  border-style: solid none none none;
`;

export const MetricDropDownWrapper = styled.div`
  width: 100%;
  justify-content: space-around;
  display: flex;
`;
